import { APP } from '../index';

export const getEventId = (state) => state[APP].eventId;
